import { useNavigate } from 'react-router-dom';
import './upload.css';
import UploadWidget from '@src/components/widgets/UploadWidget';

export default function Upload({ eventId }: { eventId: number }) {
    const navigate = useNavigate();

    const handleNext = () => {
        let tmpCreateData = {
            status: 'post',
            paging: 7,
        };
        sessionStorage.setItem('tmpCreateData', JSON.stringify(tmpCreateData));
        navigate('/register/post/7');
    };

    return (
        <UploadWidget 
            eventId={eventId}
            onNext={handleNext}
            showNextButton={true}
        />
    );
}
